export const singlePubSubConst = {
  RESET_DATE_PICKER: 'resetDatePicker',
} as const;
